module.exports = {"path":["Dashboard","Accounting","Accounting Management"]}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/accounting/management/index.json
// module id = nn4B
// module chunks = 58